module.exports = __webpack_public_path__ + "women-football.embedded.svg?e5da721e2a23ab43080e19c419047f67";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/women-football.embedded.svg
// module id = 1338
// module chunks = 37